exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nd-underline[data-v-97a01948] {\n  height: 0.373333rem;\n  margin-left: 0.013333rem;\n  margin-right: 0.013333rem;\n  top: 0.066667rem;\n  border-bottom: 0.013333rem #000000 solid;\n  display: inline-block;\n  position: relative;\n}", ""]);

// exports
